import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding-right: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  border-bottom: ", " solid ", ";\n  border-top: ", " solid\n    ", ";\n  box-sizing: border-box;\n  display: flex;\n  height: ", ";\n  margin: 0;\n  padding: 0 ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { color } from '@scp/ui-shared/theme/variables';
import { Icon } from '@scp/ui-shared/theme/icons';
import { Heading3 } from '@scp/ui-shared/components/typography';
import { baselineToRem, rem } from '@scp/ui-shared/theme/utils';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
export var HEADER_ROW_HEIGHT = 36;
var E2E_SUFFIX = '-section-header';
var Wrapper = styled.div(_templateObject(), function (props) {
  return props.secondary ? color.backgroundSecondary : color.background;
}, rem('1px'), color.border, rem('1px'), function (props) {
  return props.isFirst ? color.border : color.backgroundSecondary;
}, rem(HEADER_ROW_HEIGHT), baselineToRem(4));
var SectionIcon = styled(Icon)(_templateObject2(), baselineToRem(4));
export var SectionHeader = function SectionHeader(_ref) {
  var children = _ref.children,
      iconName = _ref.iconName,
      dataE2e = _ref.dataE2e,
      _ref$isFirst = _ref.isFirst,
      isFirst = _ref$isFirst === void 0 ? false : _ref$isFirst,
      _ref$secondary = _ref.secondary,
      secondary = _ref$secondary === void 0 ? false : _ref$secondary;
  return React.createElement(Wrapper, {
    isFirst: isFirst,
    "data-e2e": getE2eLabel(children, E2E_SUFFIX, dataE2e),
    secondary: secondary
  }, !!iconName && React.createElement(SectionIcon, {
    name: iconName,
    size: rem(18)
  }), React.createElement(Heading3, {
    noMargin: true,
    secondary: !secondary
  }, children));
};